// extracted by mini-css-extract-plugin
module.exports = {"root":"InputError_root__O4WdG"};